// extracted by mini-css-extract-plugin
module.exports = {"component":"components-Widgets-WidgetIcon__component--54DsW","history":"components-Widgets-WidgetIcon__history--3GcSp"};